/* eslint-disable sonarjs/no-duplicate-string */
import {WIX_ECOM} from '@wix/app-definition-ids';
import {PageMap, StoresWidgetID} from '@wix/wixstores-client-core/dist/es/src/constants';
import {EditorSDK} from '@wix/platform-editor-sdk';
import {SPECS} from '../constants';
import {Experiments} from '../../common/experiments/Experiments';

export const SideCartControllerName = 'sideCartLightboxController';
export const createLightbox = async (
  sdk: EditorSDK,
  managingAppDefId: string,
  isResponsive: boolean = false,
  t: (key: string) => string,
  experiments: Experiments
) => {
  const isEditor3 = globalThis?.commonConfig?.host === 'EDITOR3';
  const shouldUseSideCartPopupContainerForEditor3 =
    experiments.enabled(SPECS.SideCartPopupContainerForEditor3) && isEditor3;
  const tpaApplicationId = (await sdk.tpa.app.getDataByAppDefId('', WIX_ECOM)).applicationId;

  const options = shouldUseSideCartPopupContainerForEditor3
    ? ({
        title: t('pages_panel_ecomPlatform_sideCart'),
        hideTitle: true,
        shouldNavigateToPage: false,
        controllerType: SideCartControllerName,
        popupRole: PageMap.SIDE_CART,
        definition: {
          data: {
            tpaPageId: 'ecom_side_cart',
            managingAppDefId,
            appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
          },
          style: {
            styleType: 'custom',
            style: {
              properties: {
                'alpha-bg': '0.3',
                bg: 'color_15',
              },
              propertiesSource: {
                'alpha-bg': 'value',
                bg: 'theme',
              },
              groups: {},
            },
            type: 'ComponentStyle',
            skin: 'wysiwyg.viewer.skins.page.ResponsivePageWithColorBG',
          },
          components: [
            {
              type: 'Container',
              layout: {
                x: 0,
                y: 0,
                fixedPosition: false,
                width: 160,
                height: 90,
                scale: 1,
                rotationInDegrees: 0,
              },
              componentType: 'wixSystemElements.PopupContainer',
              parent: 'uu4ti',
              components: [],
              metaData: {
                pageId: 'uu4ti',
                sig: 'gee-723',
              },
              innerElements: {
                type: 'wixSystemElements.PopupContainer.InnerElementsMap',
                metaData: {
                  schemaVersion: '1.0',
                  isPreset: false,
                  isHidden: false,
                  pageId: 'uu4ti',
                  sig: 'gee-725',
                },
                innerElements: {
                  closeButton: {
                    type: 'InnerElement',
                    referredType: 'wixSystemElements.PopupContainer|closeButton',
                    metaData: {
                      schemaVersion: '1.0',
                      isPreset: false,
                      isHidden: false,
                      pageId: 'uu4ti',
                      sig: 'gee-728',
                    },
                    scopedStyles: {},
                    style: {
                      type: 'wixSystemElements.PopupContainer|closeButton.Style',
                      cssProperties: {
                        display: 'none',
                      },
                      spx: {
                        refWidth: 1280,
                        resolverType: 'scale',
                      },
                      metaData: {
                        schemaVersion: '1.0',
                        isPreset: false,
                        isHidden: false,
                        pageId: 'uu4ti',
                        sig: 'gee-726',
                      },
                    },
                  },
                },
              },
              editorsettings: {
                type: 'EditorSettings',
                disableAutoDOMOrder: true,
                metaData: {
                  schemaVersion: '1.0',
                  isPreset: false,
                  isHidden: false,
                  pageId: 'uu4ti',
                  sig: 'gee-396',
                },
              },
              measurements: {
                type: 'MeasurementsData',
                x: 860,
                y: 0,
                width: 420,
                height: 1273,
                viewportSize: 1280,
                isFixedPosition: true,
                metaData: {
                  schemaVersion: '1.0',
                  isPreset: false,
                  isHidden: false,
                  pageId: 'uu4ti',
                  sig: 'gee-733',
                },
              },
              connections: {
                type: 'ConnectionList',
                items: [
                  {
                    type: 'WixCodeConnectionItem',
                    role: '6A30Caff5Dc34E4CBa7019Db988F583002905E252A964E68802Eb494Fe0081101',
                  },
                ],
                metaData: {
                  schemaVersion: '1.0',
                  isPreset: false,
                  isHidden: false,
                  pageId: 'uu4ti',
                  sig: 'gee-400',
                },
              },
              scopedLayouts: {
                'variants-mkdug5qs1': {
                  componentLayout: {
                    hidden: false,
                    type: 'ComponentLayout',
                    width: {
                      value: 93.84615384615384,
                      type: 'percentage',
                    },
                    height: {
                      type: 'auto',
                    },
                    minHeight: {
                      value: 0,
                      type: 'spx',
                    },
                  },
                  itemLayout: {
                    alignSelf: 'stretch',
                    justifySelf: 'end',
                    margins: {
                      left: {
                        type: 'percentage',
                        value: 0,
                      },
                      right: {
                        type: 'percentage',
                        value: 0,
                      },
                      top: {
                        type: 'spx',
                        value: 0,
                      },
                      bottom: {
                        type: 'spx',
                        value: 0,
                      },
                    },
                    type: 'FixedItemLayout',
                  },
                  containerLayout: {},
                  spx: {
                    refWidth: 390,
                    resolverType: 'scale',
                  },
                  type: 'SingleLayoutData',
                  metaData: {
                    schemaVersion: '1.0',
                    isPreset: false,
                    isHidden: false,
                    pageId: 'uu4ti',
                    sig: 'gee-574',
                  },
                },
              },
              layouts: {
                containerLayout: {},
                spx: {
                  refWidth: 1280,
                  resolverType: 'scale',
                },
                componentLayout: {
                  minHeight: {
                    type: 'spx',
                    value: 0,
                  },
                  hidden: false,
                  height: {
                    type: 'percentage',
                    value: 100,
                  },
                  minWidth: {
                    type: 'px',
                    value: 0,
                  },
                  type: 'ComponentLayout',
                  width: {
                    type: 'px',
                    value: 420,
                  },
                  maxWidth: {
                    type: 'px',
                    value: 99999,
                  },
                  maxHeight: {
                    type: 'px',
                    value: 99999,
                  },
                },
                itemLayout: {
                  type: 'FixedItemLayout',
                  margins: {
                    top: {
                      type: 'spx',
                      value: 0,
                    },
                    bottom: {
                      type: 'spx',
                      value: 0,
                    },
                    right: {
                      type: 'percentage',
                      value: 0,
                    },
                    left: {
                      type: 'percentage',
                      value: 0,
                    },
                  },
                  justifySelf: 'end',
                  alignSelf: 'stretch',
                },
                type: 'SingleLayoutData',
                metaData: {
                  schemaVersion: '1.0',
                  isPreset: false,
                  isHidden: false,
                  pageId: 'uu4ti',
                  sig: 'gee-393',
                },
              },
              layoutSettings: {
                autoResponsivenessSettings: {
                  lastGroupingsHash: '92e861b16d8a7afb9a36e51630687d18',
                },
                type: 'LayoutSettings',
                metaData: {
                  schemaVersion: '1.0',
                  isPreset: false,
                  isHidden: false,
                  pageId: 'uu4ti',
                  sig: 'gee-580',
                },
              },
              scopedLayoutSettings: {
                'variants-mkdug5qs1': {
                  autoResponsivenessSettings: {},
                  type: 'LayoutSettings',
                  metaData: {
                    schemaVersion: '1.0',
                    isPreset: false,
                    isHidden: false,
                    pageId: 'uu4ti',
                    sig: 'gee-694',
                  },
                },
              },
              style: {
                cssCustomProperties: {
                  'overlay-opacity': '60%',
                  'overlay-color': '#000',
                },
                spx: {
                  refWidth: 1265,
                  resolverType: 'scale',
                },
                type: 'wixSystemElements.PopupContainer.Style',
                metaData: {
                  schemaVersion: '1.0',
                  isPreset: false,
                  isHidden: false,
                  pageId: 'uu4ti',
                  sig: 'gee-395',
                },
              },
              slots: {
                type: 'wixSystemElements.PopupContainer.Slots',
                slots: {
                  children: {
                    type: 'Container',
                    layout: {
                      x: 0,
                      y: 0,
                      fixedPosition: false,
                      width: 160,
                      height: 90,
                      scale: 1,
                      rotationInDegrees: 0,
                    },
                    componentType: 'wixSystemElements.InternalContainer',
                    parent: 'comp-mkdug5py2',
                    components: [
                      {
                        type: 'Component',
                        skin: 'wysiwyg.viewer.skins.TPASectionSkin',
                        layout: {},
                        layouts: {
                          containerLayout: {},
                          componentLayout: {
                            hidden: false,
                            height: {
                              type: 'auto',
                            },
                            type: 'ComponentLayout',
                            width: {
                              type: 'percentage',
                              value: 100,
                            },
                          },
                          itemLayout: {
                            alignSelf: 'center',
                            margins: {
                              left: {
                                type: 'percentage',
                                value: 0,
                              },
                              right: {
                                type: 'percentage',
                                value: 0,
                              },
                              top: {
                                type: 'percentage',
                                value: 0,
                              },
                              bottom: {
                                type: 'percentage',
                                value: 0,
                              },
                            },
                            justifySelf: 'center',
                            type: 'FixedItemLayout',
                          },
                          type: 'SingleLayoutData',
                        },
                        componentType: 'wysiwyg.viewer.components.tpapps.TPAMultiSection',
                        data: {
                          type: 'TPAMultiSection',
                          applicationId: '24',
                          appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
                          widgetId: '49dbb2d9-d9e5-4605-a147-e926605bf164',
                        },
                      },
                      {
                        type: 'Container',
                        skin: 'wysiwyg.viewer.skins.TPASectionSkin',
                        layout: {
                          x: 0,
                          y: 0,
                          fixedPosition: false,
                          width: 420,
                          height: 815,
                          scale: 1,
                          rotationInDegrees: 0,
                        },
                        componentType: 'checkout_Orders.SideCart_legacy',
                        components: [],
                        metaData: {
                          pageId: 'uu4ti',
                          sig: 'gee-688',
                        },
                        parent: 'comp-mkdug5q9',
                        data: {
                          type: 'TPAMultiSection',
                          applicationId: '25',
                          appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
                          widgetId: '49dbb2d9-d9e5-4605-a147-e926605bf164',
                          metaData: {
                            schemaVersion: '1.0',
                            isPreset: false,
                            isHidden: false,
                            pageId: 'uu4ti',
                            sig: 'gee-417',
                          },
                        },
                        measurements: {
                          type: 'MeasurementsData',
                          x: 0,
                          y: 0,
                          width: 420,
                          height: 1273,
                          viewportSize: 1280,
                          isFixedPosition: true,
                          metaData: {
                            schemaVersion: '1.0',
                            isPreset: false,
                            isHidden: false,
                            pageId: 'uu4ti',
                            sig: 'gee-731',
                          },
                        },
                        scopedLayouts: {},
                        layouts: {
                          containerLayout: {},
                          componentLayout: {
                            hidden: false,
                            height: {
                              type: 'auto',
                            },
                            type: 'ComponentLayout',
                            width: {
                              type: 'percentage',
                              value: 100,
                            },
                          },
                          itemLayout: {
                            alignSelf: 'center',
                            margins: {
                              left: {
                                type: 'percentage',
                                value: 0,
                              },
                              right: {
                                type: 'percentage',
                                value: 0,
                              },
                              top: {
                                type: 'percentage',
                                value: 0,
                              },
                              bottom: {
                                type: 'percentage',
                                value: 0,
                              },
                            },
                            justifySelf: 'center',
                            type: 'FixedItemLayout',
                          },
                          type: 'SingleLayoutData',
                          metaData: {
                            schemaVersion: '1.0',
                            isPreset: false,
                            isHidden: false,
                            pageId: 'uu4ti',
                            sig: 'gee-418',
                          },
                        },
                        style: {
                          type: 'TopLevelStyle',
                          id: 'tpas0',
                          style: {
                            properties: {},
                            propertiesSource: {},
                            groups: {},
                          },
                          componentClassName: 'checkout_Orders.SideCart_legacy',
                          pageId: '',
                          compId: '',
                          styleType: 'system',
                          skin: 'wysiwyg.viewer.skins.TPASectionSkin',
                        },
                      },
                    ],
                    metaData: {
                      pageId: 'uu4ti',
                      sig: 'gee-421',
                    },
                    measurements: {
                      type: 'MeasurementsData',
                      x: 0,
                      y: 0,
                      width: 420,
                      height: 1273,
                      viewportSize: 1280,
                      isFixedPosition: true,
                      metaData: {
                        schemaVersion: '1.0',
                        isPreset: false,
                        isHidden: false,
                        pageId: 'uu4ti',
                        sig: 'gee-732',
                      },
                    },
                    connections: {
                      type: 'ConnectionList',
                      items: [
                        {
                          type: 'WixCodeConnectionItem',
                          role: 'internalContainer1',
                        },
                      ],
                      metaData: {
                        schemaVersion: '1.0',
                        isPreset: false,
                        isHidden: false,
                        pageId: 'uu4ti',
                        sig: 'gee-406',
                      },
                    },
                    scopedLayouts: {
                      'variants-mkdug5qs1': {
                        componentLayout: {
                          hidden: true,
                          type: 'ComponentLayout',
                        },
                        itemLayout: {},
                        containerLayout: {},
                        type: 'SingleLayoutData',
                        metaData: {
                          schemaVersion: '1.0',
                          isPreset: false,
                          isHidden: false,
                          pageId: 'uu4ti',
                          sig: 'gee-577',
                        },
                      },
                    },
                    layouts: {
                      containerLayout: {
                        columnGap: {
                          type: 'spx',
                          value: 0,
                        },
                        autoFlow: 'row',
                        autoRows: [
                          {
                            type: 'minContent',
                          },
                        ],
                        rowGap: {
                          type: 'spx',
                          value: 0,
                        },
                        columns: [
                          {
                            type: 'MinMaxSize',
                            min: {
                              type: 'px',
                              value: 0,
                            },
                            max: {
                              type: 'fr',
                              value: 1,
                            },
                          },
                        ],
                        autoColumns: [
                          {
                            type: 'fr',
                            value: 1,
                          },
                        ],
                        padding: {
                          left: {
                            value: 0,
                            type: 'spx',
                          },
                          right: {
                            value: 0,
                            type: 'spx',
                          },
                          top: {
                            value: 0,
                            type: 'spx',
                          },
                          bottom: {
                            value: 0,
                            type: 'spx',
                          },
                        },
                        type: 'GridContainerLayout',
                        rows: [
                          {
                            type: 'MinMaxSize',
                            min: {
                              type: 'spx',
                              value: 326.21875,
                            },
                            max: {
                              type: 'auto',
                            },
                          },
                        ],
                      },
                      spx: {
                        refWidth: 1280,
                        resolverType: 'scale',
                      },
                      componentLayout: {
                        minHeight: {
                          type: 'spx',
                          value: 0,
                        },
                        height: {
                          type: 'percentage',
                          value: 100,
                        },
                        minWidth: {
                          type: 'px',
                          value: 0,
                        },
                        type: 'ComponentLayout',
                        width: {
                          type: 'percentage',
                          value: 100,
                        },
                        maxWidth: {
                          type: 'px',
                          value: 99999,
                        },
                        maxHeight: {
                          type: 'px',
                          value: 99999,
                        },
                      },
                      itemLayout: {},
                      type: 'SingleLayoutData',
                      metaData: {
                        schemaVersion: '1.0',
                        isPreset: false,
                        isHidden: false,
                        pageId: 'uu4ti',
                        sig: 'gee-403',
                      },
                    },
                  },
                },
              },
            },
          ],
        },
      } as any)
    : ({
        title: t('pages_panel_ecomPlatform_sideCart'),
        hideTitle: true,
        shouldNavigateToPage: false,
        controllerType: SideCartControllerName,
        popupRole: PageMap.SIDE_CART,
        definition: {
          data: {
            tpaApplicationId,
            tpaPageId: PageMap.SIDE_CART,
            managingAppDefId,
            appDefinitionId: WIX_ECOM,
            ...(!isResponsive
              ? {
                  pageBackgrounds: {
                    desktop: {
                      custom: true,
                      ref: {
                        type: 'BackgroundMedia',
                        color: '{color_15}',
                        colorOpacity: 0.3,
                        alignType: 'top',
                        fittingType: 'fill',
                        scrollType: 'fixed',
                      },
                      isPreset: true,
                    },
                    mobile: {
                      custom: true,
                      ref: {
                        type: 'BackgroundMedia',
                        color: '{color_15}',
                        colorOpacity: 0.3,
                        alignType: 'top',
                        fittingType: 'fill',
                        scrollType: 'fixed',
                      },
                      isPreset: true,
                    },
                  },
                }
              : {}),
          },
          components: [
            {
              type: 'Container',
              components: [
                {
                  type: 'Component',
                  skin: 'wysiwyg.viewer.skins.TPASectionSkin',
                  layout: {
                    width: 420,
                    height: 815,
                    x: 0,
                    y: 0,
                    scale: 1,
                    rotationInDegrees: 0,
                    fixedPosition: false,
                  },
                  ...(isResponsive
                    ? {
                        layouts: {
                          containerLayout: {},
                          componentLayout: {
                            hidden: false,
                            height: {
                              type: 'auto',
                            },
                            type: 'ComponentLayout',
                            width: {
                              type: 'percentage',
                              value: 100,
                            },
                          },
                          itemLayout: {
                            alignSelf: 'center',
                            margins: {
                              left: {
                                type: 'percentage',
                                value: 0,
                              },
                              right: {
                                type: 'percentage',
                                value: 0,
                              },
                              top: {
                                type: 'percentage',
                                value: 0,
                              },
                              bottom: {
                                type: 'percentage',
                                value: 0,
                              },
                            },
                            justifySelf: 'center',
                            type: 'FixedItemLayout',
                          },
                          type: 'SingleLayoutData',
                        },
                      }
                    : {}),
                  componentType: 'wysiwyg.viewer.components.tpapps.TPAMultiSection',
                  data: {
                    type: 'TPAMultiSection',
                    applicationId: tpaApplicationId.toString(),
                    appDefinitionId: WIX_ECOM,
                    widgetId: StoresWidgetID.SIDE_CART,
                  },
                },
              ],
              skin: 'wysiwyg.viewer.skins.area.RectangleArea',
              layout: {
                width: 420,
                x: 0,
                y: 0,
              },
              ...(isResponsive
                ? {
                    layouts: {
                      containerLayout: {},
                      componentLayout: {
                        minHeight: {
                          type: 'px',
                          value: 100,
                        },
                        hidden: false,
                        height: {
                          type: 'percentage',
                          value: 100,
                        },
                        minWidth: {
                          type: 'px',
                          value: 0,
                        },
                        type: 'ComponentLayout',
                        width: {
                          type: 'px',
                          value: 420,
                        },
                        maxWidth: {
                          type: 'px',
                          value: 99999,
                        },
                      },
                      itemLayout: {
                        alignSelf: 'stretch',
                        margins: {
                          left: {
                            type: 'px',
                            value: 0,
                          },
                          right: {
                            type: 'px',
                            value: 0,
                          },
                          top: {
                            type: 'px',
                            value: 0,
                          },
                          bottom: {
                            type: 'px',
                            value: 0,
                          },
                        },
                        justifySelf: 'end',
                        type: 'FixedItemLayout',
                      },
                      type: 'SingleLayoutData',
                      metaData: {
                        isHidden: false,
                        isPreset: false,
                      },
                    },
                  }
                : {}),
              componentType: 'wysiwyg.viewer.components.PopupContainer',
              props: {
                type: 'PopupContainerProperties',
                alignmentType: 'fullHeight',
                horizontalAlignment: 'right',
                verticalAlignment: 'top',
                horizontalOffset: 0,
                verticalOffset: 0,
              },
              style: {
                ...(isResponsive
                  ? {
                      type: 'ComponentStyle',
                      style: {
                        propertiesOverride: {},
                        properties: {
                          'alpha-bg': '1',
                          bg: 'color_11',
                        },
                        propertiesSource: {
                          'alpha-bg': 'value',
                          bg: 'theme',
                        },
                        groups: {},
                      },
                      componentClassName: 'wysiwyg.viewer.components.PopupContainer',
                      styleType: 'custom',
                      skin: 'wysiwyg.viewer.skins.screenwidthcontainer.ResponsivePopupContainerWithColorBG',
                    }
                  : {}),
              },
              ...(!isResponsive
                ? {
                    design: {
                      background: {
                        colorLayers: [
                          {
                            fill: {
                              type: 'SolidColor',
                              color: 'color_11',
                            },
                            opacity: 1,
                            type: 'SolidColorLayer',
                          },
                        ],
                      },
                    },
                  }
                : {}),
            },
          ],
          style: {
            ...(isResponsive
              ? {
                  styleType: 'custom',
                  style: {
                    properties: {
                      'alpha-bg': '0.3',
                      bg: 'color_15',
                    },
                    propertiesSource: {
                      'alpha-bg': 'value',
                      bg: 'theme',
                    },
                    groups: {},
                  },
                  type: 'ComponentStyle',
                  skin: 'wysiwyg.viewer.skins.page.ResponsivePageWithColorBG',
                }
              : {}),
          },
        },
      } as any);

  return sdk.document.pages.popupPages.addConnected('', options);
};
